<script>
/**
 *
 * @version 1.0.0
 * @since
 */
export default {};
</script>
<template>
  <font-awesome-icon icon="exchange-alt"/>
</template>
<style lang="scss" scoped></style>
